import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as earlyAccessService from "../../services/early-access.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import {
  formateDateWithMonth,
  TrimText,
} from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import { THEME_COLORS } from "../../../../utils/Constants";
import StatusFilter from "../../common/statusFilter";
import { Tooltip, Whisper, Placeholder } from "rsuite";
import * as $ from 'jquery';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const EarlyAccessTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const [statsupdate, setStatusUpdate] = useState(false);
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({ column: "createdAt", order: "descending" });
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);

  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Early Access Requests", url: "" },
  ];

  const showStatusFilterList = [
    { name: "All Status", status__id: "" },
    { name: "Pending", status__id: "PENDING" },
    { name: "Contacted", status__id: "CONTACTED" },
    { name: "Rejected", status__id: "REJECTED" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      setLoader(true);
      const paramsData = {
        limit: itemperpage,
        page: params.pgno || 1,
        sorting: JSON.stringify(sorting),
        filters: JSON.stringify(search),
        global_search: globalsearch
      };
      
      earlyAccessService.List(paramsData)
        .then((response) => {
          if (response.success) {
            setList(response.data.list || []);
            setDataLength(response.data.total_records || response.data.list?.length || 0);
            setLoader(false);
          }
        })
        .catch((error) => {
          console.error("List error:", error);
          setLoader(false);
        });
    }, 300);
    return () => clearTimeout(getData)
  }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);

  useEffect(() => {
    if (params.pgno) {
      setPage(Number(params.pgno));
    } else {
      setPage(1);
    }
  }, [params.pgno]);

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  const prepareFilter = (key, value) => {
    let sr = { ...search };
    if (value && String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
  };

  const changeStatus = (row, newStatus) => {
    setLoader(true);
    earlyAccessService.StatusChange({ id: row.id, status: newStatus })
      .then((response) => {
        if (response.success) {
          setStatusUpdate(!statsupdate);
        } else {
          setLoader(false);
          console.error("Status change failed:", response.message);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.error("Status change error:", error);
      });
  };

  const exportPDF = () => {
    setLoader(true);
    const paramsData = {
      limit: itemperpage,
      page: params.pgno || 1,
      sorting: JSON.stringify(sorting),
      filters: JSON.stringify(search),
      global_search: globalsearch
    };

    earlyAccessService.List(paramsData)
      .then((response) => {
        if (response.success) {
          const exportData = response.data.list || [];
          const doc = new jsPDF();
          
          doc.setFontSize(22);
          doc.setTextColor(32, 128, 120); 
          doc.text("mNetrics", 14, 20);
          
          doc.setFontSize(14);
          doc.setTextColor(44, 42, 99); 
          doc.text("Early Access Requests", 14, 30);

          doc.setFontSize(9);
          doc.setTextColor(100);
          doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 37);

          const tableColumn = ["Sr. No", "Status", "Name", "Email", "Netball Profile", "Club Name", "Request Date"];
          const tableRows = [];

          exportData.forEach((row, index) => {
            const rowData = [
              ((paramsData.page - 1) * itemperpage) + index + 1,
              row.status || "N/A",
              row.name || "N/A",
              row.email || "N/A",
              row.profile || "N/A",
              row.clubName || "N/A",
              row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A",
            ];
            tableRows.push(rowData);
          });

          autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 45,
            theme: 'striped',
            headStyles: { fillColor: [32, 128, 120], fontSize: 9, fontStyle: 'bold' },
            styles: { fontSize: 8, cellPadding: 2.5 },
            alternateRowStyles: { fillColor: [248, 252, 251] },
          });

          doc.save(`EarlyAccessRequests_${new Date().getTime()}.pdf`);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Export error:", error);
        setLoader(false);
      });
  };

  const exportCSV = () => {
    setLoader(true);
    const paramsData = {
      limit: itemperpage,
      page: params.pgno || 1,
      sorting: JSON.stringify(sorting),
      filters: JSON.stringify(search),
      global_search: globalsearch
    };

    earlyAccessService.List(paramsData)
      .then((response) => {
        if (response.success) {
          const exportData = response.data.list || [];
          const headers = ["Sr. No", "Status", "Name", "Email", "Netball Profile", "Club Name", "Request Date"];
          const csvContent = [
            headers.join(","),
            ...exportData.map((row, index) => {
              const rowData = [
                ((paramsData.page - 1) * itemperpage) + index + 1,
                row.status || "N/A",
                `"${(row.name || "N/A").replace(/"/g, '""')}"`,
                `"${(row.email || "N/A").replace(/"/g, '""')}"`,
                `"${(row.profile || "N/A").replace(/"/g, '""')}"`,
                `"${(row.clubName || "N/A").replace(/"/g, '""')}"`,
                row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A",
              ];
              return rowData.join(",");
            })
          ].join("\n");

          const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
          const link = document.createElement("a");
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", `EarlyAccessRequests_${new Date().getTime()}.csv`);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Export error:", error);
        setLoader(false);
      });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                Early Access Requests
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => prepareFilter("createdAt", e)}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showStatusFilterList}
                    prepareFilter={prepareFilter}
                    selectedStatus={search?.status || ""}
                  />
                </div>
                <button
                  type="button"
                  onClick={exportPDF}
                  className="btn ripple btn-secondary signbtn me-2"
                  disabled={loader}
                >
                  <i className="ri-file-pdf-line me-1"></i> Export PDF
                </button>
                <button
                  type="button"
                  onClick={exportCSV}
                  className="btn ripple btn-info signbtn me-3"
                  disabled={loader}
                >
                  <i className="ri-file-excel-line me-1"></i> Export CSV
                </button>
                <button
                  type="reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {loader ?
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              :
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered border-t0 card-table border-top text-nowrap w-100">
                    <thead>
                      <tr>
                        <th>{t("list_heading_sno")}</th>
                        <th>{t("list_heading_status")}</th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("list_heading_name")}</span>
                            <Sorting sort={sorting} handleSort={handleSort} column="name" />
                          </div>
                        </th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("label_email")}</span>
                            <Sorting sort={sorting} handleSort={handleSort} column="email" />
                          </div>
                        </th>
                        <th>Netball Profile</th>
                        <th>Club Name</th>
                        <th>
                          <div className="sorting_column">
                            <span>Request Date</span>
                            <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="createdAt" />
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.length ? (
                        list.map((row, i) => (
                          <tr key={i}>
                            <td>{((page - 1) * itemperpage) + i + 1}</td>
                            <td>
                              <div className="dropdown d-inline-flex align-items-center gap-1">
                                <Whisper
                                  placement="top"
                                  trigger="hover"
                                  speaker={
                                    <Tooltip>Change Status</Tooltip>
                                  }
                                >
                                  <span
                                    className="dropdown-toggle no-after"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i
                                      className="ri-settings-5-fill"
                                      style={{
                                        color: "#000000",
                                        fontSize: "18px",
                                        cursor: "pointer",
                                        marginRight: "4px",
                                      }}
                                    ></i>
                                  </span>
                                </Whisper>
                                <ul className="dropdown-menu">
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() => changeStatus(row, "PENDING")}
                                    >
                                      Pending
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() => changeStatus(row, "CONTACTED")}
                                    >
                                      Contacted
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() => changeStatus(row, "REJECTED")}
                                    >
                                      Rejected
                                    </button>
                                  </li>
                                </ul>
                                {(() => {
                                  if (row.status === "PENDING") return <span className="badge badge-pill badge-primary-light">Pending</span>
                                  if (row.status === "CONTACTED") return <span className="badge badge-pill badge-success-light">Contacted</span>
                                  if (row.status === "REJECTED") return <span className="badge badge-pill badge-danger-light">Rejected</span>
                                  return <span className="badge badge-pill badge-info-light">{row.status}</span>
                                })()}
                              </div>
                            </td>
                            <td>{row.name ? TrimText(row.name, 50) : "N/A"}</td>
                            <td>{row.email ? TrimText(row.email, 50) : "N/A"}</td>
                            <td>{row.profile || "N/A"}</td>
                            <td>{row.clubName || "N/A"}</td>
                            <td>{row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} className="text-center">{t("msg_no_records")}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3">
                  <b>{t("msg_total_records")} : {datalength || "0"}</b>
                </div>
                {datalength > 0 && (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[{ name: "Early Access", path: "/admin/early-access/list" }]}
                  />
                )}
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default EarlyAccessTable;
